import { nsDfs, nsQ, nsXd } from "@qdabra/forms-shared/xmlNamespaces";
import { ensureSlash } from "@qdabra/forms-shared/urlHelpers";
import { __ } from "ramda";
import { nsAdoDfs } from "../formsviewer/constants.namespaces";
import { buildNamespaceManagerFromMap } from "../utility/xmlHelpers";

export const dataFieldsPath = "dfs:myFields/dfs:dataFields";

function getDfsNode(dom, name) {
    return dom.documentElement.getElementsByTagNameNS(nsDfs, name)[0];
}

function getDfsChild(dom, dfsNodeName) {
    const node = dom && getDfsNode(dom, dfsNodeName);

    return node && node.firstElementChild;
}

// DataSource -> DomNode
export function getQueryXml(dom) {
    return getDfsChild(dom, "queryFields");
}

export function getDataFieldsContent(dom) {
    return getDfsChild(dom, "dataFields");
}

export function getDataFieldsNode(dom) {
    return getDfsNode(dom, "dataFields");
}



function isAbsolutePath(path) {
    if (!path) {
        return true;
    }

    return /^[a-zA-Z]+:\/\//.test(path);
}

export function combinePath(basePath, possiblyRelativePath) {
    if (!basePath || isAbsolutePath(possiblyRelativePath)) {
        return possiblyRelativePath;
    }

    basePath = ensureSlash(basePath);

    var splitRelativePath = possiblyRelativePath.split("/");

    splitRelativePath.forEach(function (segment, i) {
        if (segment === "..") {
            basePath = basePath.replace(/[^/]+\/?$/, "");
        } else if (segment !== "") {
            basePath += segment +
                (i !== splitRelativePath.length - 1
                    ? "/"
                    : '');
        }
    });

    return basePath;
}


export const getMainDom = (dataSourceCollection) =>
    dataSourceCollection
        .getDataSource("")
        .getDom();

const makeStandardNamespaces = () =>
    buildNamespaceManagerFromMap({
        dfs: nsDfs,
        xd: nsXd,
        listq: nsQ,
        adod: nsAdoDfs,
    })

export const standardNamespaces = makeStandardNamespaces();